import { axiosV2, getError, getResponse, settings } from '../../helpers/UtilsHelper';

const { app } = settings;
const { urls } = app?.backend;

export class LlmModelService {

    static getAll = async ({
        data = {},
        token = '',
        languageId = 'en',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'LlmModelService - getAll';
        let response = getResponse({ type: 0 });
        try {
            const url = `${urls?.url}${urls?.apiV1}${urls?.llmModels}/`;
            const headers = { authorization: `bearer ${token}`, languageId: languageId };
            response = await axiosV2?.post({
                url: url,
                data: data,
                headers,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    static getById = async ({
        id = '',
        token = '',
        languageId = 'en',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'LlmModelService - getById';
        let response = getResponse({ type: 0 });
        try {
            const url = `${urls?.url}${urls?.apiV1}${urls?.llmModels}/${id}`;
            const headers = { authorization: `bearer ${token}`, languageId: languageId };
            response = await axiosV2?.get({
                url: url,
                headers: headers,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    static delete = async ({
        id = '',
        token = '',
        languageId = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'LlmModelService - delete';
        let response = getResponse({ type: 0 });
        try {
            const url = `${urls?.url}${urls?.apiV1}${urls?.llmModels}/${id}`;
            const headers = { authorization: `bearer ${token}`, languageId: languageId };
            response = await axiosV2?.delete({
                url: url,
                headers: headers,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    static create = async ({
        data = {},
        token = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'LlmModelService - create';
        let response = getResponse({ type: 0 });
        try {
            const url = `${urls?.url}${urls?.apiV1}${urls?.llmModels}/`;
            const headers = { authorization: `bearer ${token}` };
            response = await axiosV2?.post({
                url: url,
                data: data,
                headers: headers,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    static update = async ({
        id = '',
        data = {},
        token = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'LlmModelService - update';
        let response = getResponse({ type: 0 });
        try {
            const url = `${urls?.url}${urls?.apiV1}${urls?.llmModels}/${id}`;
            const headers = { authorization: `bearer ${token}` };
            response = await axiosV2?.post({
                url: url,
                data: data,
                headers: headers,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }
}
